// console.log('REFILLS EXPERIENCE LOADED!');

// SHOW ALL ACTIVE LINERS IN GRID
const showAllActiveLiners = () => {
  const $linerCodesContainer = $('.CollectionChooseLiner__codes');

  $linerCodesContainer.addClass('filter-applied');
  // hide all liners at the start
  $('#refills-liners')
    .find('.ProductVariantTile')
    .removeClass('Animate--animated')
    .hide()
    .addClass('Animate--animated');

  $linerCodesContainer.find('.CollectionChooseLiner__code.active').each((i, el) => {
    // get div element within el
    const $liner_code_circle = $(el).find('.liner-code-circle');
    const liner_code = $liner_code_circle.data('liner-code');
    const gridElements = document.querySelectorAll(`[data-product-liner-code="${liner_code}"]`);
    // loop through each grid element and show it with each
    gridElements.forEach((gridElement) => {
      // remove class to gridElement
      gridElement.classList.remove('Animate--animated');
      // show gridElement
      gridElement.style.display = 'block';
      // add class to gridElement but we need to delay here so the animation can finish
      setTimeout(() => {
        gridElement.classList.add('Animate--animated');
      }, 100);
    });
  });

  // if no active liners, show all liners (reset)
  if ($linerCodesContainer.find('.CollectionChooseLiner__code.active').length === 0) {
    $linerCodesContainer.removeClass('filter-applied');
    $('#refills-liners').find('.ProductVariantTile').show().addClass('Animate--animated');
  }
};

// FILTER LINERS BASED ON DATA-LINER-CODE
$('.CollectionChooseLiner__code').on('click', (e) => {
  const $target = $(e.currentTarget);
  $('.CollectionChooseLiner__codes').removeClass('filter-applied');

  // ANY TIME A LINER IS CLICKED WE REMOVE ACTIVE CLASS FROM ITEMS
  $('.CollectionChooseLiner__code').removeClass('active');

  // IF TARGET IS ACTIVE: REMOVE ACTIVE CLASS AND SHOW ALL ACTIVE LINERS
  if ($target.hasClass('active')) {
    $target.removeClass('active');
    showAllActiveLiners();
    return;
  }

  // IF TARGET IS NOT ACTIVE: REMOVE ACTIVE CLASS FROM ITEMS AND ADD TO TARGET, THEN SHOW ALL ACTIVE LINERS
  $target.addClass('active');

  showAllActiveLiners();

  let offset_mod = 160;
  // MOBILE ONLY: SCROLL TO TARGET LINER IN GRID
  if (window.innerWidth <= 767) {
    offset_mod = 107;
    const $liner_code_circle = $target.find('.liner-code-circle');
    const liner_code = $liner_code_circle.data('liner-code');

    // find gridElement by the product's liner_code AND that product is available
    let gridElement = document.querySelector(
      `[data-product-liner-code="${liner_code}"][data-product-available="true"]`
    );

    // if gridElement is null, then all products of this liner code are out of stock; find by just liner code
    if (!gridElement) {
      gridElement = document.querySelector(`[data-product-liner-code="${liner_code}"]`);
    }

    const offset = gridElement.offsetTop - offset_mod;
    window.scrollTo({
      top: offset,
      behavior: 'smooth',
    });
  }
});

// CHECK IF URL HAS FILTER PARAM + SELECT OPTION IF SO
const checkForLinerCodeParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('linerCode')) {
    const linerCode = urlParams.get('linerCode');
    $(`[data-liner-code="${linerCode}"]`).trigger('click');
  }
  return false;
};

$(document).ready(() => {
  setTimeout(() => {
    checkForLinerCodeParam();
  }, 500);
});

// MAIN SUBNAV CLICK LOGIK
const $subNavItem = $('.refills-subnav-item');
const $subNavCardItemsContainer = $('.refills-subnav-card-items-container');
const $subNavCardItem = $('.refills-subnav-card-item');
const $collectionContainer = $('.FilteredProductVariantGrid');
const $ProductVariantTile = $('.ProductVariantTile');
const $refillsSoapContainer = $('#refills-soap');

const $quickBuyForm = $('.QuickBuy__form');
const $quickBuyAddToCart = $('[data-quick-buy-atc]');
const $quickBuyVariantItem = $('.QuickBuy__variant-item');
const $quickBuyBackInStockEmbed = $('.BIS-CollectionTileEmbed');
const $quickBuyBackInStockClose = $('.BIS-CollectionTileEmbed--close');
const $quickBuyBackInStockTrigger = $('[data-quick-buy-bis-trigger]');

$subNavItem.on('click', (e) => {
  const $target = $(e.currentTarget);
  const targetCollection = $target.attr('data-target-collection');

  // ACTIVE LOGIK
  $subNavItem.not($target).removeClass('active');
  $target.addClass('active');

  // SCROLL BACK TO TOP OF PAGE
  $('html, body').animate({ scrollTop: $('#MainContent').offset().top - 150 }, 'slow');

  // FIND TARGET COLLECTION TO DISPLAY
  $collectionContainer.not(targetCollection).hide();
  $(`#${targetCollection}`).show();
});

const showMatchingSoapRefills = (targetProducts) => {
  // SHOW ALL SOAP REFILLS LOGIK
  if (targetProducts === 'showAll') {
    $subNavCardItemsContainer.removeClass('filter-applied');
    $refillsSoapContainer
      .find($ProductVariantTile)
      .removeClass('Animate--animated')
      .show()
      .delay(100)
      .addClass('Animate--animated');
    return;
  }

  // FIND TARGET PRODUCTS TO SHOW/HIDE
  $refillsSoapContainer.find($ProductVariantTile).each((i, el) => {
    const $productTileContainer = $(el);
    const productNameGeneric = $productTileContainer.data('refills-filter');

    $productTileContainer.hide().removeClass('Animate--animated');

    if (productNameGeneric === targetProducts) {
      $productTileContainer.removeClass('Animate--animated').show().delay(100).addClass('Animate--animated');
    }
  });
};

// CHILD SUBNAV CLICK LOGIK
$subNavCardItem.on('click', (e) => {
  const $target = $(e.currentTarget);
  const targetProducts = $target.attr('data-target-products');

  // ACTIVE LOGIK
  if ($target.hasClass('active')) {
    $target.removeClass('active');
    showMatchingSoapRefills('showAll');
  } else {
    $subNavCardItemsContainer
      .addClass('filter-applied')
      .find('.refills-subnav-card-item.active')
      .not($target)
      .removeClass('active');
    $target.addClass('active');
    showMatchingSoapRefills(targetProducts);
  }
});

//--------quick-buy--------------//

const removeSubscriptionStuff = ($subscriptionTarget) => {
  // console.log('removeSubscriptionStuff:', $subscriptionTarget);

  $('[data-product-has-subscriptions]')
    .not($subscriptionTarget)
    .find('[data-show-subscription-options]')
    .removeClass('subscription-selected')
    .removeClass('active')
    .removeClass('selected-variant-oos');
  $('[data-product-has-subscriptions]')
    .not($subscriptionTarget)
    .find('.ProductInfo__subscriptions-options')
    .removeClass('is-visible');
  $('[data-product-has-subscriptions]')
    .not($subscriptionTarget)
    .find('.ProductInfo__subscriptions-option')
    .removeClass('selected');
  $('[data-product-has-subscriptions]').not($subscriptionTarget).find('[data-selected-subscription-copy]').text('');
  $('[data-product-has-subscriptions]').not($subscriptionTarget).find('[data-selling-plan-id]').val('');
  $('[data-product-has-subscriptions]')
    .not($subscriptionTarget)
    .find('[data-quickbuy-subscriptions-original-price]')
    .empty();
  $('[data-product-has-subscriptions]').not($subscriptionTarget).find('[data-quickbuy-subscriptions-price]').empty();
  $('[data-product-has-subscriptions]')
    .not($subscriptionTarget)
    .find('[data-quickbuy-subscriptions-default-savings]')
    .show();
  // $('[data-product-has-subscriptions]').not($subscriptionTarget).find('[data-quickbuy-subscriptions-savings]').empty();
  $('[data-product-has-subscriptions]').removeClass('subscription-dropdown-open');
  $('body').removeClass('subscription-dropdown-open');
};

const resetForms = ($targetForm, $productTileWithSubscriptionsTarget) => {
  $quickBuyForm.not($targetForm).trigger('reset').find($quickBuyAddToCart).attr('disabled', 'disabled');
  $quickBuyBackInStockEmbed.fadeOut(300).removeClass('show-bis-modal');
  $quickBuyBackInStockTrigger.hide();
  $quickBuyAddToCart.show();
  $('[data-bis-success]').hide();

  // REMOVE SUBSCRIPTION STUFF W/IN QUICKBUY TILE W/ TARGET
  removeSubscriptionStuff($productTileWithSubscriptionsTarget);
};

// REFILLS UPDATE FOR QUICKBUY ATC
$quickBuyVariantItem.on('click', function () {
  const $closestForm = $(this).closest('form');
  resetForms($closestForm);
  const quickBuyVariantID = $(this).find('input[type="radio"]').data('id');
  $closestForm.find('input[name="id"]').val(quickBuyVariantID);
  $closestForm.find($quickBuyBackInStockTrigger).hide();
  $closestForm.find($quickBuyAddToCart).removeAttr('disabled').show();

  // VARIANT OOS BIS LOGIK
  if ($(this).hasClass('variant-oos')) {
    // console.log('VARIANT IS OOS: TRIGGER BIS LOGIK');

    const $ProductVariantTileClosest = $(this).closest($ProductVariantTile);
    const $BIS_trigger = $ProductVariantTileClosest.find($quickBuyBackInStockTrigger);
    //    const $BIS_form = $ProductVariantTileClosest.find('[data-bis-form]');

    // HIDE ATC BUTTON AND SHOW BIS TRIGGER
    $closestForm.find($quickBuyAddToCart).hide();
    $closestForm.find($BIS_trigger).show();

    // $BIS_elem.fadeIn(300).addClass('show-bis-modal');
    //    $BIS_form.find('[data-bis-variant]').val(quickBuyVariantID);
  }
});

/*
  // QUICKBUY VARIANT OOS BIS SHOW LOGIK
  $quickBuyBackInStockTrigger.on('click', function() {
    const $ProductVariantTileClosest = $(this).closest($ProductVariantTile);
    const $BIS_elem = $ProductVariantTileClosest.find($quickBuyBackInStockEmbed);
    $BIS_elem.fadeIn(300).addClass('show-bis-modal');
  });

  // QUICKBUY VARIANT OOS BIS HIDE LOGIK
  $quickBuyBackInStockClose.on('click', function() {
    const $BIS_elem = $(this).closest($quickBuyBackInStockEmbed);
    $BIS_elem.fadeOut(300).removeClass('show-bis-modal');
    $('[data-bis-success]').hide();
  });
*/
// DISABLE QUICKBUY ATC BUTTON WHEN CHANGING VIEWS
$('[data-target-collection]').on('click', (e) => {
  const colllectionHandle = $(e.currentTarget).data('target-collection');
  window.history.replaceState(
    { ...window.history.state },
    '',
    `${window.theme.local_subfolder}/collections/${colllectionHandle}`
  );
  resetForms();
});

// QUICKBUY ATC BUTTON LOGIK

// INIT SUBSCRIPTION LOGIK WITHIN PRODUCT TILE
const $productTileWithSubscriptions = $('[data-product-has-subscriptions]');

if ($productTileWithSubscriptions.length > 0) {
  // console.warn('PRODUCT TILE HAS SUBSCRIPTIONS! DO THE MAGIK!');

  $productTileWithSubscriptions.each(function () {
    const $productTileWithSubscriptionsTarget = $(this);
    const $closestForm = $productTileWithSubscriptionsTarget.find('form');
    const $showSubscriptionOptions = $productTileWithSubscriptionsTarget.find('[data-show-subscription-options]');
    const $subscriptionOptions = $productTileWithSubscriptionsTarget.find('.ProductInfo__subscriptions-options');
    const $subscriptionOption = $productTileWithSubscriptionsTarget.find('.ProductInfo__subscriptions-option');
    const $subscriptionOptionSelectedCopy = $productTileWithSubscriptionsTarget.find(
      '[data-selected-subscription-copy]'
    );
    const $subscriptionInput = $productTileWithSubscriptionsTarget.find('[data-selling-plan-id]');

    // LOGIK TO SHOW/HIDE SUBSCRIPTION OPTIONS DROPDOWN
    $showSubscriptionOptions.on('click', (e) => {
      // console.log('showSubscriptionOptions clicked!');
      const $this = $(e.currentTarget);

      resetForms($closestForm, $productTileWithSubscriptionsTarget);

      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $subscriptionOptions.removeClass('is-visible');
        $productTileWithSubscriptionsTarget.removeClass('subscription-dropdown-open');
        $('body').removeClass('subscription-dropdown-open');
      } else {
        $this.addClass('active');
        $subscriptionOptions.addClass('is-visible');
        $productTileWithSubscriptionsTarget.addClass('subscription-dropdown-open');
        $('body').addClass('subscription-dropdown-open');
      }
    });

    // LOGIK TO UPDATE HIDDEN VALUES WITH THE SELECTED SUBSCRIPTION FROM DROPDOWN
    $subscriptionOption.on('click', (e) => {
      // console.log('subscriptionOption clicked!');
      e.stopImmediatePropagation();

      const $this = $(e.currentTarget);
      const subscriptionSelectedCopy = $this.data('subscription-selected-copy');
      const subscriptionSelectedCopyRedux = subscriptionSelectedCopy.split(' ');
      const subscriptionSelectedCopyReduxHTML = `<span class="Text-Style--bolder">${subscriptionSelectedCopyRedux[0]} ${subscriptionSelectedCopyRedux[1]}</span> ${subscriptionSelectedCopyRedux[2]} ${subscriptionSelectedCopyRedux[3]} ${subscriptionSelectedCopyRedux[4]}`;
      // console.log(subscriptionSelectedCopyReduxHTML);
      const subscriptionID = $this.data('subscription-id');
      const variantID = $this.data('variant-id');
      const variantOriginalPrice = $this.data('variant-original-price');
      const variantPrice = $this.data('variant-price');
      // const variantSavings = $this.data('variant-savings');

      if ($this.hasClass('selected')) {
        $this.removeClass('selected');

        resetForms();
      } else {
        // INITIAL LOGIK TO JUST UNSELECT ANY OTHER OPTIONS + SELECT THIS ONE CLICKED
        $subscriptionOptions.find($subscriptionOption).removeClass('selected');
        $this.addClass('selected');

        // ON CLICK OF SUBSCRIPTION OPTION, HIDE SUBSCRIPTION OPTIONS DROPDOWN
        $showSubscriptionOptions.addClass('subscription-selected').removeClass('active');
        $subscriptionOptions.removeClass('is-visible');
        $productTileWithSubscriptionsTarget.removeClass('subscription-dropdown-open');
        $('body').removeClass('subscription-dropdown-open');
        $showSubscriptionOptions.removeClass('selected-variant-oos');

        // UPDATE SUBSCRIPTION COPY + ID IN HIDDEN INPUT
        // $subscriptionOptionSelectedCopy.text(subscriptionSelectedCopy);
        $subscriptionOptionSelectedCopy.html(subscriptionSelectedCopyReduxHTML);
        $subscriptionInput.val(subscriptionID);

        // UPDATE SELECTED VARIANT W/IN HIDDEN INPUT
        $closestForm.find('input[name="id"]').val(variantID);
        $closestForm.find('input[data-id]').prop('checked', false);

        // UPDATE SELECTED VARIANT PRICE + SAVINGS
        // console.log(variantPrice, variantSavings);
        $closestForm.find($('[data-quickbuy-subscriptions-original-price]')).html(variantOriginalPrice);
        $closestForm.find($('[data-quickbuy-subscriptions-price]')).html(variantPrice);
        $closestForm.find($('[data-quickbuy-subscriptions-default-savings]')).hide();
        // $closestForm.find($('[data-quickbuy-subscriptions-savings]')).html(variantSavings);

        // UPDATE ATC STATUS ON THE PRODUCT TILE
        $closestForm.find($quickBuyBackInStockTrigger).hide();
        $closestForm.find($quickBuyAddToCart).removeAttr('disabled').show();

        // CHECK IF VARIANT IS OOS AND TRIGGER BIS LOGIK FROM SUBSCRIPTION DROPDOWN
        if ($this.hasClass('variant-oos')) {
          // console.log('VARIANT IS OOS: TRIGGER BIS LOGIK');

          const $ProductVariantTileClosest = $this.closest($ProductVariantTile);
          const $BIS_trigger = $ProductVariantTileClosest.find($quickBuyBackInStockTrigger);
          const $BIS_form = $ProductVariantTileClosest.find('[data-bis-form]');

          $showSubscriptionOptions.addClass('selected-variant-oos');

          // HIDE ATC BUTTON AND SHOW BIS TRIGGER
          $closestForm.find($quickBuyAddToCart).hide();
          $closestForm.find($BIS_trigger).show();

          // $BIS_elem.fadeIn(300).addClass('show-bis-modal');
          $BIS_form.find('[data-bis-variant]').val(variantID);
        }
      }
    });
  });
}
